import {OptionModel} from 'models/configuration/OptionModel'
import {PackKey, PackModel} from 'models/configuration/PackModel'
import {TourModel} from 'models/configuration/TourModel'
import {EventModel} from 'models/EventModel'
import {SummitType} from 'types'
import {Memoize} from 'util/memoize'

export type TrackKey = string

export type TrackConfig = {
	key: string
	label: string
	date: string
	summit: SummitType
	title: string
	subtitle: string
	text: string
	tag: string
}

export class TrackModel {
	event: EventModel
	config: TrackConfig

	constructor(event: EventModel, config: TrackConfig) {
		this.event = event
		this.config = config
	}

	@Memoize()
	get key(): TrackKey {
		return this.config.key
	}

	@Memoize()
	get date(): TrackKey {
		return this.config.date
	}

	@Memoize()
	get summit(): SummitType {
		return this.config.summit
	}

	@Memoize()
	get label(): string {
		return this.config.label
	}

	@Memoize()
	get profile_title(): string {
		return this.config.title
	}

	@Memoize()
	get profile_subtitle(): string {
		return this.config.subtitle
	}

	@Memoize()
	get profile_text(): string {
		return this.config.text
	}

	@Memoize()
	get packs(): Array<PackModel> {
		return this.event.packs.filter(pack => pack.tracksSet.has(this))
	}

	@Memoize()
	get tours(): Array<TourModel> {
		return this.event.tours.filter(tour => tour.track === this)
	}

	@Memoize()
	get exclusiveOptions(): Array<OptionModel> {
		return this.event.options.filter(
			option => option.tracks.length === 1 && option.tracks[0] === this
		)
	}

	isIncludedIn(packs: Set<PackKey>): boolean {
		return !!this.packs.find(pack => packs.has(pack.key))
	}

	alternativePack(): PackKey | undefined {
		return this.packs.find(
			pack => pack.tracks.length === 1 && pack.tracksSet.has(this)
		)?.key
	}
}
